import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMicellarWaterGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M32.705 18.2c-.098-.8-.59-1.5-1.377-1.9l-3.738-2v-3.5s.099 0 .099-.1c1.082-.7 1.18-1.3 1.082-1.7-.099-.4-.492-.9-1.77-1-.788 0-1.673.1-2.657.3-1.672.5-3.54 1.4-3.639 2.5V14.1l-4.033 2.2c-.688.4-1.278 1.1-1.377 1.9-.492 3.5-.59 15 2.164 20.6l.099.1c.688.8 3.934 1.1 6.688 1.1 1.279 0 2.459-.1 3.148-.1 2.36-.2 2.852-.7 3.147-1.1 2.754-5.6 2.656-17.2 2.164-20.6ZM24.64 9.6c1.475-.4 2.459-.3 2.852-.2-.098.1-.393.3-.689.5-.491.2-1.082.5-1.869.7-1.475.3-2.459.3-2.852.2l.295-.3c.394-.3 1.18-.7 2.263-.9Zm1.77 1.8V14h-4.426v-2c.295.1.59.1.885.1.787 0 1.574-.1 2.36-.3.394-.1.788-.3 1.18-.4Zm3.05 26.8c-.886.8-9.837.8-10.919 0-1.475-3-2.066-8-2.262-12.4.787-1 1.672-.5 4.623 1.6l.098.1c.984.7 1.869 1 2.656 1 1.869 0 3.344-1.5 4.721-2.7.492-.5.885-.9 1.377-1.3.59-.4 1.082-.6 1.476-.6.295 0 .491.2.59.3-.099 4.8-.689 10.7-2.36 14Zm1.868-15.5c-.787-.1-1.574.2-2.459.8-.492.4-.984.9-1.475 1.3-2.164 2.1-3.64 3.2-5.804 1.6l-.098-.1c-2.164-1.6-3.934-2.9-5.41-2.2 0-2.5.098-4.6.295-5.9.099-.4.295-.8.689-1l4.13-2.2h5.312l4.132 2.2c.393.2.59.6.688 1 .197 1 .295 2.6.295 4.5 0 .1-.098 0-.295 0Z",
    fill: "currentColor"
  }));
}

export { SvgMicellarWaterGlyph as default };
